import { ClientRepo } from "@services/clients/client.repo";
import { extractErrorMessage } from "@common/utils/errorUtils";

class PortfolioTransferController {
  public client: any;
  public portfolio: any;
  selectedItem: any;
  searchText: string;
  public clients: any[];
  public oldClient: any;
  public isLoading: boolean = false;

  /** Shown on hover for "What does this mean?" (native title tooltip). */
  public readonly transferPortfolioHelpTooltip =
    "• Moves the portfolio, all of its external accounts, and related balances to the destination client.\n" +
    "• Detaches the portfolio from its current portfolio fee and creates a matching new fee on the destination (unapproved), including copied setup fees where applicable.\n" +
    "• Removes all links to the portfolio on the old client's portfolio fees.\n" +
    "• Management fee parameters in final run are reset to temp run and tied to the destination client and the new fee.\n" +
    "• Instruction-sheet history is not changed (audit).";

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private clientRepo: ClientRepo,
    private $stateParams: angular.ui.IStateParamsService,
    private notifyjs: any
  ) {}

  $onInit() {
    this.isLoading = true;
    this.clientRepo
      .getClientsForSelection()
      .then((response: any) => {
        this.clients = (response.data as { id: number; clientNumber: string; displayName: string }[])
          .filter((c) => c.displayName && c.displayName.trim() !== "")
          .map((c) => ({
            id: c.id,
            clientNumber: c.clientNumber,
            name: c.displayName,
            displayText: c.clientNumber ? `${c.clientNumber} - ${c.displayName}` : c.displayName,
          }));
      })
      .catch((err) => this.notifyjs(extractErrorMessage(err)))
      .finally(() => {
        this.isLoading = false;
      });
  }

  save() {
    if (!this.client || !this.oldClient || !this.portfolio) {
      return;
    }

    const portfolioId = this.portfolio.portfolioId || this.portfolio.id;
    if (!portfolioId || portfolioId <= 0) {
      this.notifyjs("Unable to transfer portfolio: missing portfolio id.");
      return;
    }

    this.isLoading = true;
    this.clientRepo
      .transferPortfolio({
        oldClientId: this.oldClient.id,
        newClientId: this.client.id,
        portfolioId,
      })
      .then((res) => {
        this.$mdDialog.hide(res.data);
      })
      .catch((err) => this.notifyjs(extractErrorMessage(err)))
      .finally(() => {
        this.isLoading = false;
      });
  }

  clearSearchTerm() {
    this.searchText = "";
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
export const portfolioTransfer: angular.IComponentOptions = {
  template: require("./portfolioTransfer.modal.html"),
  controller: PortfolioTransferController,
  bindings: {
    portfolio: "<",
    oldClient: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/portfolio/modals/portfolioTransfer.modal.ts